import { useQuery } from 'react-query';
import InAppNotificationsApi from 'app/api/inAppNotifications';
import { queryKey } from 'constants/queryKey';
import { ApiClientError } from 'api/client';
import { NotificationCount } from 'types/InAppNotification';

const useInAppNotificationsCountQuery = () =>
  useQuery<NotificationCount, ApiClientError>(
    queryKey.inAppNotificationsCount(),
    InAppNotificationsApi.getUnseenCount,
  );

export default useInAppNotificationsCountQuery;
